import styled from 'styled-components';

// CONSTANTS
import { WHITE, SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  &.carousel-wtw,
  .carousel-wtw {
    &__title {
      margin-bottom: 15px;
    }

    &--want-to-watch {
      .carousel-wtw__title {
        position: relative;
        margin-bottom: -30px;
        margin-right: 80px;
        z-index: 2;
      }
    }
  }
`;

export const WhatToWatchWrapper = styled.div`
  .card-wrapper {
    &--see-all {
      .dummy-card {
        position: relative;
        background-color: ${WHITE};
        border-radius: 6px;
        height: 100%;
        padding-top: 150%;

        &__content {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          i {
            font-size: 36px;
            color: ${SANTAS_GRAY};
            margin-bottom: 20px;
          }

          span {
            color: ${p => p.theme.palette.text.primary};
          }
        }
      }
    }
  }

  .swiper-slide {
    width: 120px;
  }

  ${breakpoints.up('sm')} {
    .swiper-slide {
      width: 160px;
    }
  }

  ${breakpoints.down('xs')} {
    .swiper-slide {
      width: 104px;

      .movie-card__title {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
`;

export default Container;
